import Vue from 'vue';
import axios from 'axios';
import router from 'src/router';
import {globalConfig} from 'static/config'
// 先判断环境，带端口的就默认访问本地
if (!!location.port) {
    //static/config.js
    //Vue.prototype.HOST_PROXY_ADMIN = 'http://192.168.111.45:8080';//后端项目地址
    //Vue.prototype.FONT_PROXY_PATH = 'http://192.168.111.45:9090';//前端项目地址
    Vue.prototype.HOST_PROXY_ADMIN = globalConfig.HOST_PROXY_ADMIN;//后端项目地址
    Vue.prototype.FONT_PROXY_PATH = globalConfig.FONT_PROXY_PATH;//前端项目地址
} else {
    Vue.prototype.HOST_PROXY_ADMIN = globalConfig.HOST_PROXY_ADMIN;//后端项目地址
    Vue.prototype.FONT_PROXY_PATH = globalConfig.FONT_PROXY_PATH;//前端项目地址
    //Vue.prototype.HOST_PROXY_ADMIN = 'http://permission-admin.yuanjy.com'; //need change location.origin.replace(/test/, 'admin');
}

// 创建axios实例
const axiosInstance = axios.create({
    baseURL: Vue.prototype.HOST_PROXY_ADMIN,
    //timeout: 25000,
    timeout: 5 * 60 * 1000,
});
// 添加请求拦截器
axiosInstance.interceptors.request.use(function (config) {
    // 非 HOST_PROXY_ADMIN 域名下的请求，均不拦截
    if (config.url.includes(Vue.prototype.HOST_PROXY_ADMIN)) {
        config.emulateJSON = true;
        config.withCredentials = true;
        config.headers['X-TOKEN'] = localStorage.getItem('x-token');

        if (config.headers['Content-Type'] == null) {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        }
        //可用于批量上传文件
        if (config.headers['Content-Type'].includes('multipart/form-data')) {
            const {data} = config;
            let formData = new FormData();

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                    if (key.endsWith('[]')) {
                        data[key].forEach(item => {
                            formData.append(key, item);
                        })
                    } else {
                        formData.append(key, data[key]);
                    }
                }
            }

            config.data = formData;
        }
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// 添加响应拦截器
axiosInstance.interceptors.response.use(function (response) {
    // 用户未登陆 或者 用户被禁用，重定向到登录页面
    if (response.data.code == 101003 || response.data.code == 101013) {
        localStorage.clear();
        // 只有当当前不在登录页面时才重定向
        if (router.currentRoute.path !== '/login') {
            router.replace({
                path: '/login',
            });
        }
    }
    // 返回结果code编码不为0时，显示错误信息
    if (response.data.code > 0) {
        return Promise.reject(response.data.message);
    }
    return response;
}, function (error) {
    let str = '网络错误，请稍后再试'
    switch (error.response.status) {
        case 400:
            str = '您的请求错误'
            break
        case 401:
            str = '您还未授权，请重新登陆'
            break
        case 403:
            str = '您的权限不足，拒绝访问'
            break
        case 404:
            str = '请求错误，资源未找到'
            break
        case 405:
            str = '您的请求未允许'
            break
        case 408:
            str = '您的请求超时'
            break
        case 500:
            str = '服务器端错误'
            break
        case 501:
            str = '网络未实现'
            break
        case 502:
            str = '网络错误'
            break
        case 503:
            str = '服务不可用'
            break
        case 504:
            str = '网络超时'
            break
        case 505:
            str = 'HTTP版本不支持该请求'
            break
    }
    return Promise.reject(str);
});

// 创建 API 实例
const createAPI = (url, method, config = {}) => {
    return axiosInstance({
        url,
        method,
        ...config
    });
};

export default createAPI;



// WEBPACK FOOTER //
// ./src/api/axios.js